import styled from 'styled-components';

const List = styled.div`
    list-style-type: square;
    display: table;

    li {
        display: table-row;
    }

    li::before {
        padding-right: 0.5rem;
        content: "▪︎";
        display: table-cell;
        text-align: right;
    }
`;

export default List;